export default __webpack_public_path__ + "static/snow-bc26ea8bac3a85f653d145c36a1cda34.png";